import React from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

import Icon from 'assets/icons';
import styles from './MenuLink.module.scss';

interface MenuLinkProps {
  to?: string;
  href?: string;
  type?: string;
  target?: '_blank' | '_self';
  selected?: boolean;
  className?: string;
  Component?: any;
  linkClassName?: string;
  showMenuCheckmarks?: boolean;
  onClick?: ((event: any) => void) | null;
}

export const MenuLink: React.FC<MenuLinkProps> = ({
  type,
  selected = false,
  className,
  linkClassName,
  showMenuCheckmarks = false,
  Component,
  ...props
}) => {
  if (!Component) {
    if (props.to) {
      Component = NavLink;
    } else if (props.href) {
      Component = 'a';
    } else {
      Component = 'div';
    }
  }

  const classes = classNames(linkClassName, styles.menuLink, {
    [styles.clickable]: !!props.onClick || !!props.to || !!props.href,
    [styles[`type-${type}`]]: type,
  });

  return (
    <li className={classNames(styles.menuItem, className)}>
      <Component {...props} className={classes} />
      {selected && showMenuCheckmarks && <Icon.Checkmark className={styles.checkmark} />}
    </li>
  );
};

export default MenuLink;
